import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import TopBar from './TopBar';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-206">
      <TopBar data-id="element-207" />
      <Navbar data-id="element-208" />
      <main className="flex-grow" data-id="element-209">{children}</main>
      <Footer data-id="element-210" />
    </div>;
};
export default Layout;